module.exports = __webpack_public_path__ + "greenlight-bookstore.6abbcf3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/greenlight-bookstore.jpg
// module id = 659
// module chunks = 0